const firebaseConfig = {
    apiKey: "AIzaSyC9osmG5y7vjkzvaoMs6bJqzJlCy8U4JiI",
    authDomain: "expo-real.firebaseapp.com",
    projectId: "expo-real",
    storageBucket: "expo-real.appspot.com",
    messagingSenderId: "600358168362",
    appId: "1:600358168362:web:349791cb25bf63f76f6053"
};

const vapidKey = "BI3hgKfXTfkAHmnAX9wevQ9h_IikkPRgmuX5xjqC-3zF-ikkY0fP4V1ZeUlYhfvQFZgkz8tByfE1UdmOiNUIKr4";

export {
    firebaseConfig,
    vapidKey
}